import { Col, Row } from 'antd'
import _ from 'lodash'
import momentTZ from 'moment-timezone'
import React, { Component } from 'react'
import { I18n } from 'react-redux-i18n'

import { KDMStatuses } from '../../common/enums'
import { formatDateTime } from '../../common/util/helper'

class KDMTableContentItem extends Component {
  getKDMStatusDetails () {
    const {theatre} = this.props
    const kdmScreens = theatre.screens.filter(s => s.isKdmIssued)
    let KDMStatus = theatre.kdms.map(kdm => {
      const {id, validFrom, validTill, device: {serial, manufacturer, model, screen}, status: {type, detail, subDetail}, deliveryStatus} = kdm
      let statusType = type
      let statusDetail = detail
      let statusSubDetail = subDetail

      if (!_.isEmpty(deliveryStatus) && !_.isEmpty(deliveryStatus.emails)) {
        statusType = KDMStatuses.emailed
        statusDetail = deliveryStatus.emails.map(email => email.to).join(', ')
        statusSubDetail = ''
      }

      return {
        model,
        serial,
        manufacturer,
        kdmId: id,
        validFrom,
        validTill,
        statusType,
        statusDetail,
        statusSubDetail,
        screenName: screen.name,
        screenId: screen.id,
        deliveryStatus
      }
    })

    kdmScreens.forEach(s => {
      if (_.isEmpty(KDMStatus.find(d => d.screenId === s.id))) {
        KDMStatus.push({
          screenName: s.name,
          screenId: s.id,
          statusType: KDMStatuses.inprogress
        })
      }
    })

    return KDMStatus
  }

  getStatusDetail (statusType, statusDetail) {
    switch (statusType.toLowerCase()) {
      case KDMStatuses.emailed:
        return `to ${statusDetail}`
      case KDMStatuses.success:
        return null
      default:
        return statusDetail
    }
  }

  getDeviceInformation (deviceInfo) {
    let info = []
    if (deviceInfo.manufacturer) {
      info.push(deviceInfo.manufacturer)
    }

    if (deviceInfo.model) {
      info.push(deviceInfo.model)
    }

    if (deviceInfo.serial) {
      info.push(deviceInfo.serial)
    }

    return info.join('::')
  }

  getDetail (KDMStatusDetails) {
    const {theatre: {timezone}} = this.props
    return _.sortBy(KDMStatusDetails, ['screenName']).map((info, idx) => {
      const subDetail = this.getStatusDetail(info.statusType, info.statusDetail)
      return (
        <Row key={idx} className="kdm-table-content-detail qw-mt-x-small qw-pb-x-small qw-border-bottom">

          <Col span={8} className='qw-px-x-small'>
            <p className="screen-name qw-font-size-small qw-color-text-body qw-line-height-small">
             {
              info.screenName
              ?
              info.screenName
              :
              I18n.t('compositions.standByServer')
              }
            </p>
            <p className="screen-info qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small">{this.getDeviceInformation(info)}</p>
          </Col>

          <Col span={7} className='qw-px-x-small'>
            <p className={`status qw-font-size-small qw-color-text-body qw-line-height-small ${info.statusType.toLowerCase()}`}>
              {I18n.t(`compositions.kdmStatus.${info.statusType.toLowerCase()}`)}
            </p>
            <p className="status-detail qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small qw-truncate qw-pr-x-small"
             title={subDetail}>
              {subDetail}
            </p>
          </Col>

          <Col span={9} className='qw-px-x-small'>
            <p className="validity qw-font-size-small qw-color-text-body qw-line-height-small">
            {
              info.validFrom && info.validTill
              ?
              `${formatDateTime(momentTZ.tz(info.validFrom, timezone))} to ${formatDateTime(momentTZ.tz(info.validTill, timezone))}`
              : null
            }
            </p>
          </Col>
          
        </Row>
      )
    })
  }

  render () {
    const KDMStatusDetails = this.getKDMStatusDetails()
    return <div className="kdm-table-content">{this.getDetail(KDMStatusDetails)}</div>
  }
}

export default KDMTableContentItem



// WEBPACK FOOTER //
// ./src/app/components/compositions/KDMTableContentItem.js